import { Box } from "@mui/material";
import { DotLegalButton, DotLegalPageHeader } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "@localization/useTranslation.ts";
import { useInputFields } from "./InputFields.hooks.ts";
import InputFieldAddEditDialog from "./inputFieldAddEditDialog/InputFieldAddEditDialog.tsx";
import DotLegalTabs from "../../common/components/dotLegalTabs/DotLegalTabs.tsx";
import { TabContent } from "@common/components/dotLegalTabs/DotLegalTabs.types.ts";
import StandardInputFieldTab from "./standardInputFieldTab/StandardInputFieldTab.tsx";
import CustomInputFieldTab from "./customInputFieldTab/CustomInputFieldTab.tsx";
import { TemplateEntityType } from "../EntityTemplate.types.ts";

export interface InputFieldsProps {
    templateEntityType: TemplateEntityType;
}

function InputFields(props: InputFieldsProps) {
    const { translateString } = useTranslation();
    const { breadCrumbs, selectedTab, setSelectedTab, showCreateDialog, setShowCreateDialog, onSaved } = useInputFields(props);

    let tabContent: Array<TabContent> = [
        {
            index: 1,
            label: translateString("customFields"),
            content: <CustomInputFieldTab templateEntityType={props.templateEntityType} />,
        },
        {
            index: 2,
            label: translateString("standardFields"),
            content: <StandardInputFieldTab templateEntityType={props.templateEntityType} />,
        },
    ];

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    <DotLegalButton buttonType={"primary"} size="medium" onClick={() => setShowCreateDialog(true)}>
                        {translateString("createInputField")}
                    </DotLegalButton>
                }
            />

            <DotLegalTabs
                ignoreTextTransformation
                noPadding
                fillColumn
                tabStyle={"secondary"}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                content={tabContent}
                fullWidth={false}
            />

            {showCreateDialog && (
                <InputFieldAddEditDialog templateEntityType={props.templateEntityType} onDialogClose={() => setShowCreateDialog(false)} onSaved={onSaved} />
            )}
        </Box>
    );
}

export default InputFields;
